var _circle, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sad",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_810",
    "data-name": "Ellipse 810",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37782",
    "data-name": "Path 37782",
    d: "M110.073,80.073A30,30,0,0,1,56.72,98.907,30,30,0,0,0,98.907,56.72,29.968,29.968,0,0,1,110.073,80.073Z",
    transform: "translate(-50.073 -50.073)",
    fill: "#f4c534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37783",
    "data-name": "Path 37783",
    d: "M172.814,298.406a2.257,2.257,0,0,0,2.852-2.231,12.3,12.3,0,0,0-24.589.021,2.255,2.255,0,0,0,2.835,2.233A37.321,37.321,0,0,1,172.814,298.406Z",
    transform: "translate(-133.371 -251.044)",
    fill: "#3e4347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37784",
    "data-name": "Path 37784",
    d: "M210.115,357.861a4.523,4.523,0,0,0-4.425-5.509,4.471,4.471,0,0,0-3.163,1.286,4.6,4.6,0,0,0-1.785-.358,4.537,4.537,0,0,0-4.534,4.534c0,.028.007.054.009.082A37.1,37.1,0,0,1,210.115,357.861Z",
    transform: "translate(-173.215 -311.061)",
    fill: "#e24b4b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37785",
    "data-name": "Path 37785",
    d: "M391.628,284.4c0-2.137-3.87-8.707-3.87-8.707s-3.87,6.57-3.87,8.707a3.87,3.87,0,1,0,7.74,0Z",
    transform: "translate(-338.901 -243.388)",
    fill: "#65b1ef"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15433",
    "data-name": "Group 15433",
    transform: "translate(10.532 5.518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37786",
    "data-name": "Path 37786",
    d: "M299.042,185.955l-3.351-3.654c-3.853-4.189-10.783-4.311-10.86-4.311l-1.9-.015,1.4-1.3a6.216,6.216,0,0,1,5.574-1.95c4.219.823,6.93,6.488,7.037,6.731Z",
    transform: "translate(-260.304 -159.679)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37787",
    "data-name": "Path 37787",
    d: "M276.028,47.088c7.684,8.642,10.029,9.069,12.675,11.437a13.235,13.235,0,0,1-8.381-3.456C277.185,52.115,276,49.008,276.028,47.088Z",
    transform: "translate(-254.213 -47.088)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37788",
    "data-name": "Path 37788",
    d: "M89.872,185.955l3.351-3.654c3.853-4.189,10.783-4.311,10.86-4.311l1.9-.015-1.4-1.3a6.216,6.216,0,0,0-5.574-1.95c-4.219.823-6.93,6.488-7.037,6.731Z",
    transform: "translate(-89.872 -159.679)",
    fill: "#3e4347"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37789",
    "data-name": "Path 37789",
    d: "M138.787,47.088c-7.684,8.642-10.029,9.069-12.675,11.437a13.235,13.235,0,0,0,8.381-3.456C137.632,52.115,138.815,49.008,138.787,47.088Z",
    transform: "translate(-121.865 -47.088)",
    fill: "#3e4347"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_15434",
    "data-name": "Group 15434",
    transform: "translate(48.985 40.792)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37790",
    "data-name": "Path 37790",
    d: "M419.962,350.043c-.542.645-1.331.909-1.721.555-.409-.336-.281-1.142.277-1.789s1.314-.909,1.721-.555C420.649,348.592,420.521,349.4,419.962,350.043Z",
    transform: "translate(-418.001 -348.093)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.33e9cbaa933022942e5a1efa74edfc98.svg";
export { ForwardRef as ReactComponent };